<template>
  <Tooltip :text="tooltipText" :show-icon="false">
    <HeraFormBtn
      :label="$t('_web_tournament_results-export-csv', 'Export results')"
      class="mx-2"
      :loading="isLoading"
      :disabled="!isCompetitionFinished"
      @click.native="exportToCSV"
    />
  </Tooltip>
</template>

<script>
import downloadFakeLink from '@/utils/downloadFile';
import { mapActions, mapGetters } from 'vuex';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import Tooltip from '@/components/molecules/InfoTooltip';
import loadingMixin from '@/mixins/isLoading';

const FINISHED_STATUSES = ['finished'];

export default {
  components: { HeraFormBtn, Tooltip },
  mixins: [loadingMixin],
  props: {
    stageID: {
      type: String,
      default: '',
    },
    blockID: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['currentTournamentStage']),
    competitionStatus() {
      return this.$lodash.get(this.currentTournamentStage, 'status');
    },
    isCompetitionFinished() {
      return FINISHED_STATUSES.includes(this.competitionStatus);
    },
    tooltipText() {
      return this.isCompetitionFinished
        ? this.$t(
            '_web_tournament_results-export-csv-tooltip',
            'Export results to CSV file'
          )
        : this.$t(
            '_web_tournament_results-export-blocked-tooltip',
            'Results export is available only for finished competitions'
          );
    },
  },
  methods: {
    ...mapActions(['getTournamentResultsCSV', 'errorNotify']),
    exportToCSV() {
      this.setLoading();
      this.getTournamentResultsCSV({
        stage: this.stageID,
        block: this.blockID,
      })
        .then(res => {
          downloadFakeLink(
            new Blob([res], { type: 'text/csv' }),
            this.fileName
          );
        })
        .catch(this.errorNotify)
        .finally(this.unsetLoading);
    },
  },
};
</script>
